module.exports = __webpack_public_path__ + "img/scroll-arrow-right.062be891.svg";